/**
 * The Routing Paths Service instance.
 */
export class RoutingPathsService {
  /**
   * The paths object
   */
  static paths = {
    domain: '',
    home: 'home',
    error: 'error',
    pageNotFound: 'pageNotFound',
  };

  /**
   * Is route path method.
   *
   * @param url The url identifier
   * @returns Boolean
   */
  static isRoutePath(url: string): boolean {
    let result = false;
    Object.values(this.paths).forEach((value) => {
      if (url === value && value !== '') {
        result = true;
      }
    });
    return result;
  }
}
